<template>
  <div class="about">
    <div class="page_tit_box">
      <div class="center_content u-flex">
        <div>
          <img class="tit_img" src="../assets/images/index_icon1.png" alt="" />
        </div>
        <div>首页>关于我们</div>
      </div>
    </div>
    <div class="about_top_img"></div>

    <div class="cert_center">
      <div class="about_page1">
        <div class="about_tit">山西华晋工程担保有限公司</div>
        <div class="about_line"></div>
        <div class="about_txt">
          山西华晋工程担保有限公司（以下简称“华晋担保”）于2014年10月11日成立，公司注册资金人民币壹亿元，公司注册地址位于山西省太原市晋源区长兴南街8号阳光城环球金融中心3202室。公司公司主营分离式保函，以增强企业信用，降低企业经营风险为己任，是一家专注于工程保证担保业务的全国性专业担保公司。 
          华晋担保自成立以来，注重组织架构的建设，初步建立了各部门经理负责，全体员工共同参与的内部控制格局。公司的组织架构分为决策层、监督层、经营层、执行层几个方面。公司目前共有员工20余人，其中70%以上的员工具有工程、金融、贸易、法律等相关专业的学历，公司聘请并初步建立了运营及管理团队，主要高管从事金融、担保行业多年，在风险防范、分散和控制的实践中积累了一定经验。<br />
          近年来，为响应国家号召，在深化改革开放和金融改革的过程中，顺应国家金融改革政策指引和市场导向，公司通过在担保领域的创新和改进，不断增强自身业务标准化程度，以市场化的高效运营模式去满足日益增长的担保需求；借助经验丰富的专业团队和科学的内部运营、管理体制与风险控制机制，充分利用与众多金融机构广泛良好的业务合作关系，致力于提供周到的担保服务。 <br />
          <br />
          <span>我们能做什么？</span><br />
          1、投标保函<br />
          2、履约保函<br />
          3、预付款保函<br />
          4、支付保函<br />
          5、质量保证保函<br />
          6、农民工工资支付保函<br />
          <br />
          <span>我们的优势是什么？</span><br />
          传统银行办理银行保函，效率低，速度慢，需要占用授信额度或者缴纳全额保证金，保函在银行占用资本高，收费低，银行亏钱，不愿意做。我们和多家银行合作，能够形成规模效应，同时能够降低银行风险。
          <br />
          <br />
          <span>我们能帮助会员解决那些问题？</span><br />
          1、提高企业资金使用效率，减少资金压力，无需缴纳保证金；<br />
          2、能满足甲方和企业的各种需求，能出不同日期，不同银行，不同身份的多种格式保函，有利于多家企业投标同一个标段；<br />
          3、提供企业信用，企业经常使用银行保函，能够在银行积累信用，同时也可以在甲方增加信用。<br />
          4、降低企业经营风险，如果项目出现问题，先行扣除银行保证金，不会影响到企业的资金和日常运营，相当于在企业和甲方之间增加了一道缓冲垫。<br />
        </div>

        <div class="u-flex about_page2 u-row-between">
        <div class="about_sbox">
          <img class="about_sbox_img" src="../assets/images/about_icon_1.png" alt="">
          <div class="about_sbox_txt">
            节约企业现金流，传统业务中企业投标需要给招标方缴纳投标保证金，大部分投标保证金在开标结束之后需要退回，特别是部分项目需要在第一名签订合同后才能退，耽误时间。银行保函到期以后自动失效，无需退回。<br />
            <br />
            对于多标段，多家企业投标，省去很多繁琐之事。
          </div>
        </div>

        <div class="about_sbox">
          <img class="about_sbox_img" src="../assets/images/about_icon_3.png" alt="">
          <div class="about_sbox_txt">
            部分项目在中标以后，投标保证金转换为履约保证金。投标，履约都用银行保函，节省费用。<br />
            <br />
            收费低，如果缴纳保证金给招标方或者甲方，将来退还保证金时只退还本金，不退还利息，我们收费根据格式不同，收费不同，最低在1.5%/年左右。（现在一年期银行存款利率为1.75%）
          </div>
        </div>

        <div class="about_sbox">
          <img class="about_sbox_img" src="../assets/images/about_icon_2.png" alt="">
          <div class="about_sbox_txt">
            出函速度快，投标保函上午10点前提供资料，当天下午6点前出函。<br />
            手续简单，投标保函仅需企业提供招标文件和营业执照扫描件即可，无需盖章。
          </div>
        </div>
      </div>

      </div>

      

    </div>
    <div class="about_footer">
    </div>
  </div>
  
</template>

<script>
import { sesStorage } from "@/model/storage.js";
import Qs from "qs";
export default {
  name: "",
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {
    //地图API
    //创建地图设置地图中心点
    var map = new AMap.Map("map", {
      zoom: 20,
      center: [114.615783,38.045283],
    });
    //创建地图标记
    var marker = new AMap.Marker({
      position: [114.615783,38.045283],
      title: "河北省石家庄市绿地中山公馆写字楼A座2202",
      map: map,
    });
    //实例化信息窗体
    var infowindow = new AMap.InfoWindow({
      content:
        '<div style="font-weight: bold;padding-top:4px;padding-bottom:4px;font-size:14px;">山西华晋工程担保有限公司</div>'+
        '<div style="overflow: hidden;">' +
        '<div style="float:left ;width: 150px;font-size:12px;color:#333;line-height:16px;">地址：河北省石家庄市高新区中山东路1003号3楼307</div>' +
        "</div>",
      offset: new AMap.Pixel(0, -30),
      asOrigin: false,
    });
    //设置信息窗体显示
    infowindow.open(map, new AMap.LngLat(114.615783,38.045283));
    //标记点击事件
    function markerClick(e) {
      infowindow.setContent(e.target.content);
      infowindow.open(map, e.target.getPosition());
    }
    //绑定事件
    AMap.event.addListener(marker, "click", markerClick);
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.about {
  background-color: #f9fafe;
  .about_top_img {
    background: url("../assets/images/about_top.png") center center no-repeat;
    height: 400px;
    width: 100%;
  }
  .page_tit_box {
    background: #e2e4ee;
    padding: 20px 0;
    font-size: 14px;
  }
  .center_content {
    width: 1500px;
    margin: 0 auto;
    .tit_img {
      width: 14px;
      height: 18px;
      margin-right: 16px;
    }
  }
  .cert_center {
    width: 1500px;
    margin: 0 auto;
    .about_page1{
      background-color: #fff;
      overflow: hidden;
      margin-top: 30px;
      padding-bottom: 80px;
    }
    .about_tit {
      font-size: 24px;
      text-align: center;
      margin-top: 56px;
    }
    .about_line {
      width: 70px;
      height: 6px;
      background-color: #ff8d24;
      margin: 14px auto 20px auto;
    }
    .about_txt {
      font-size: 16px;
      line-height: 28px;
      text-align: left;
      width: 1184px;
      margin: 0 auto;
      span{
        font-size: 18px;
        font-weight: bold;
      }
    }
    .about_page2{
      width: 1184px;
      margin: 50px auto 0 auto;
      .about_sbox{
        width: 326px;
        height: 442px;
        background: #f4f7fe;
        border: 1px dashed #a0beff;
        text-align: center;
      }
      .about_sbox_img{
        margin-top: 30px;
      }
      .about_sbox_txt{
        padding: 0 33px;
        margin-top: 26px;
        text-align: left;
        line-height: 26px;
        font-size: 14px;
      }
    }
    .con_txt_down {
      width: 1500px;
      height: 498px;
      background-color: #a0a0a0;
      margin-top: 103px;
    }
  }
  .about_footer{
    height: 200px;
    margin-top: 78px;
    overflow: hidden;
    background: url("../assets/images/about_b_2.png") center center no-repeat;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/about.vue